// src/components/Topbar.js
import React, { useState, useEffect } from "react";
import { Navbar, Container } from "react-bootstrap";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import logoIcon from 'url:./assets/images/logo-white.png';
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { logout } from "./userSlice";
import { persistor } from "./store";


const Topbar = () => {
    const navigate = useNavigate();
    const [capabilities, setCapabilities] = useState([]);
    const [loading, setLoading] = useState(true);
    const baseUrl = process.env.REACT_APP_BASE_URL;
    let authToken = localStorage.getItem("authToken");
    const userId = localStorage.getItem('userId');
    const token = localStorage.getItem('authToken');
    const user = useSelector((state) => state.user);
  const dispatch = useDispatch();
    const config = {
    headers: { Authorization: `Bearer ${token}` }
  };
   
    const handleLogout = async () => {
    dispatch(logout());
    //persistor.purge();
    navigate("/");
        /* try {
            const response = await axios.post(
                'https://laravelapi.gcs-us.com/api/auth/logout',
                {},
                {
                    headers: {
                        'Authorization': `Bearer ${authToken}`
                    }
                }
            );

            if (response.data.message === "Logged out") {
                navigate('/');
            }
        } catch (err) {
            console.log('Logout failed:', err);
        } */
    };

    useEffect(() => {
    const fetchPRs = async () => {
      try {
        //console.log(baseUrl+'auth/allMenuss?user_id='+userId);
        const response = await axios.get(baseUrl+'auth/menusToDisplay?user_id='+userId, config);
        //console.log(response.data.data); return false;
        const data = response.data.data || [];
        //console.log(data);
        setCapabilities(data);
        //console.log(capabilities);
      } catch (error) {
        setCapabilities([]);
      } finally {
        setLoading(false);
      }
    };

    fetchPRs();
  }, []);
    return (
        <>
            <header className="topbar">
                <nav className="navbar top-navbar navbar-expand-md navbar-dark">

                    <div className="navbar-header">
                        <a className="navbar-brand" href="#">
                            <i className="wi wi-sunset"></i>
                            <img src={logoIcon} alt="homepage" className="dark-logo" style={{ width: "100%" }} />
                            <img src={logoIcon} alt="homepage" className="light-logo" style={{ width: "100%" }} /> </a>
                    </div>
                    <div className="navbar-collapse">
                        <ul className="navbar-nav me-auto">
                            <li className="nav-item"> <a className="nav-link nav-toggler d-block d-md-none waves-effect waves-dark" href="javascript:void(0)"><i className="ti-menu"></i></a> </li>
                            <li className="nav-item"> <a className="nav-link sidebartoggler d-none waves-effect waves-dark" href="javascript:void(0)"><i className="icon-menu"></i></a> </li>
                        </ul>
                        <ul className="navbar-nav my-lg-0">
                            <li className="nav-item right-side-toggle"> <a className="nav-link  waves-effect waves-light" onClick={handleLogout}><i className="ti-power-off" style={{ color: "red" }}></i></a></li>
                        </ul>
                    </div>
                </nav>
            </header>

            <aside className="left-sidebar">
                <div className="scroll-sidebar">
                    <nav className="sidebar-nav">
                        <ul id="sidebarnav">
                            <li className="user-pro"> <a className="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false"><img src="../assets/images/users/1.jpg" alt="user-img" className="img-circle" /><span className="hide-menu">Mark Jeckson</span></a>
                                <ul aria-expanded="false" className="collapse">
                                    <li><a href="javascript:void(0)"><i className="ti-user"></i> My Profile</a></li>
                                    <li><a href="javascript:void(0)"><i className="ti-wallet"></i> My Balance</a></li>
                                    <li><a href="javascript:void(0)"><i className="ti-email"></i> Inbox</a></li>
                                    <li><a href="javascript:void(0)"><i className="ti-settings"></i> Account Setting</a></li>
                                    <li><a href="javascript:void(0)"><i className="fa fa-power-off"></i> Logout</a></li>
                                </ul>
                            </li>
                            <li className="nav-small-cap">--- PERSONAL</li>
                            <li> <a className="has-arrow waves-effect waves-dark" href="/newdashboard" aria-expanded="false"><i className="ti-home"></i><span className="hide-menu">Home</span></a></li>
                            {capabilities.map((item) => (
        <li key={item.id}>
          <Link
            to={`/${item.slug}`}
            className="has-arrow waves-effect waves-dark"
          >
            <i className="ti-envelope"></i>
            <span className="hide-menu">{item.menu}</span>
          </Link>
        </li>
      ))}
                            {/* <li> <a className="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false"><i className="icon-speedometer"></i><span className="hide-menu">Dashboard <span className="badge rounded-pill bg-cyan ms-auto">4</span></span></a>
                            <ul aria-expanded="false" className="collapse">
                                <li><a href="index.html">Minimal </a></li>
                                <li><a href="index2.html">Analytical</a></li>
                                <li><a href="index3.html">Demographical</a></li>
                                <li><a href="index4.html">Modern</a></li>
                            </ul>
                        </li>
                        <li> <a className="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false"><i className="ti-layout-grid2"></i><span className="hide-menu">Apps</span></a>
                            <ul aria-expanded="false" className="collapse">
                                <li><a href="app-calendar.html">Calendar</a></li>
                                <li><a href="app-chat.html">Chat app</a></li>
                                <li><a href="app-ticket.html">Support Ticket</a></li>
                                <li><a href="app-contact.html">Contact / Employee</a></li>
                                <li><a href="app-contact2.html">Contact Grid</a></li>
                                <li><a href="app-contact-detail.html">Contact Detail</a></li>
                                <li> <a className="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false"><span className="hide-menu">Inbox</span></a>
                                    <ul aria-expanded="false" className="collapse">
                                        <li><a href="app-email.html">Mailbox</a></li>
                                        <li><a href="app-email-detail.html">Mailbox Detail</a></li>
                                        <li><a href="app-compose.html">Compose Mail</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li> <a className="has-arrow waves-effect waves-dark two-column" href="javascript:void(0)" aria-expanded="false"><i className="ti-palette"></i><span className="hide-menu">Ui <span className="badge rounded-pill bg-primary text-white ms-auto">25</span></span></a>
                            <ul aria-expanded="false" className="collapse">
                                <li><a href="ui-cards.html">Cards</a></li>
                                <li><a href="ui-user-card.html">User Cards</a></li>
                                <li><a href="ui-buttons.html">Buttons</a></li>
                                <li><a href="ui-modals.html">Modals</a></li>
                                <li><a href="ui-tab.html">Tab</a></li>
                                <li><a href="ui-tooltip-popover.html">Tooltip &amp; Popover</a></li>
                                <li><a href="ui-tooltip-stylish.html">Tooltip stylish</a></li>
                                <li><a href="ui-sweetalert.html">Sweet Alert</a></li>
                                <li><a href="ui-notification.html">Notification</a></li>
                                <li><a href="ui-progressbar.html">Progressbar</a></li>
                                <li><a href="ui-nestable.html">Nestable</a></li>
                                <li><a href="ui-range-slider.html">Range slider</a></li>
                                <li><a href="ui-timeline.html">Timeline</a></li>
                                <li><a href="ui-typography.html">Typography</a></li>
                                <li><a href="ui-horizontal-timeline.html">Horizontal Timeline</a></li>
                                <li><a href="ui-session-timeout.html">Session Timeout</a></li>
                                <li><a href="ui-session-ideal-timeout.html">Session Ideal Timeout</a></li>
                                <li><a href="ui-bootstrap.html">Bootstrap Ui</a></li>
                                <li><a href="ui-breadcrumb.html">Breadcrumb</a></li>
                                <li><a href="ui-bootstrap-switch.html">Bootstrap Switch</a></li>
                                <li><a href="ui-list-media.html">List Media</a></li>
                                <li><a href="ui-ribbons.html">Ribbons</a></li>
                                <li><a href="ui-grid.html">Grid</a></li>
                                <li><a href="ui-carousel.html">Carousel</a></li>
                                <li><a href="ui-offcanvas.html">Offcanvas</a></li>
                                <li><a href="ui-date-paginator.html">Date-paginator</a></li>
                                <li><a href="ui-dragable-portlet.html">Dragable Portlet</a></li>
                                <li><a href="ui-spinner.html">Spinner</a></li>
                                <li><a href="ui-scrollspy.html">Scrollspy</a></li>
                                <li><a href="ui-toasts.html">Toasts</a></li>
                            </ul>
                        </li>
                        <li className="nav-small-cap">--- FORMS, TABLE &amp; WIDGETS</li>
                        <li> <a className="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false"><i className="ti-layout-media-right-alt"></i><span className="hide-menu">Forms</span></a>
                            <ul aria-expanded="false" className="collapse">
                                <li><a href="form-basic.html">Basic Forms</a></li>
                                <li><a href="form-layout.html">Form Layouts</a></li>
                                <li><a href="form-addons.html">Form Addons</a></li>
                                <li><a href="form-material.html">Form Material</a></li>
                                <li><a href="form-float-input.html">Floating Lable</a></li>
                                <li><a href="form-pickers.html">Form Pickers</a></li>
                                <li><a href="form-upload.html">File Upload</a></li>
                                <li><a href="form-mask.html">Form Mask</a></li>
                                <li><a href="form-validation.html">Form Validation</a></li>
                                <li><a href="form-bootstrap-validation.html">Form Bootstrap Validation</a></li>
                                <li><a href="form-dropzone.html">File Dropzone</a></li>
                                <li><a href="form-icheck.html">Icheck control</a></li>
                                <li><a href="form-img-cropper.html">Image Cropper</a></li>
                                <li><a href="form-bootstrapwysihtml5.html">HTML5 Editor</a></li>
                                <li><a href="form-typehead.html">Form Typehead</a></li>
                                <li><a href="form-wizard.html">Form Wizard</a></li>
                                <li><a href="form-xeditable.html">Xeditable Editor</a></li>
                                <li><a href="form-summernote.html">Summernote Editor</a></li>
                                <li><a href="form-tinymce.html">Tinymce Editor</a></li>
                            </ul>
                        </li>
                        <li> <a className="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false"><i className="ti-layout-accordion-merged"></i><span className="hide-menu">Tables</span></a>
                            <ul aria-expanded="false" className="collapse">
                                <li><a href="table-basic.html">Basic Tables</a></li>
                                <li><a href="table-layout.html">Table Layouts</a></li>
                                <li><a href="table-data-table.html">Data Tables</a></li>
                                <li><a href="table-footable.html">Footable</a></li>
                                <li><a href="table-jsgrid.html">Js Grid Table</a></li>
                                <li><a href="table-responsive.html">Responsive Table</a></li>
                                <li><a href="table-bootstrap.html">Bootstrap Tables</a></li>
                                <li><a href="table-editable-table.html">Editable Table</a></li>
                            </ul>
                        </li>
                        <li> <a className="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false"><i className="ti-settings"></i><span className="hide-menu">Widgets</span></a>
                            <ul aria-expanded="false" className="collapse">
                                <li><a href="widget-data.html">Data Widgets</a></li>
                                <li><a href="widget-apps.html">Apps Widgets</a></li>
                                <li><a href="widget-charts.html">Charts Widgets</a></li>
                            </ul>
                        </li>
                        <li className="nav-small-cap">--- EXTRA COMPONENTS</li>
                        <li> <a className="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false"><i className="ti-files"></i><span className="hide-menu">Pages <span className="badge rounded-pill bg-info">25</span></span></a>
                            <ul aria-expanded="false" className="collapse">
                                <li><a href="starter-kit.html">Starter Kit</a></li>
                                <li><a href="pages-blank.html">Blank page</a></li>
                                <li><a href="javascript:void(0)" className="has-arrow">Authentication <span className="badge rounded-pill bg-success pull-right">6</span></a>
                                    <ul aria-expanded="false" className="collapse">
                                        <li><a href="pages-login.html">Login 1</a></li>
                                        <li><a href="pages-login-2.html">Login 2</a></li>
                                        <li><a href="pages-register.html">Register</a></li>
                                        <li><a href="pages-register2.html">Register 2</a></li>
                                        <li><a href="pages-register3.html">Register 3</a></li>
                                        <li><a href="pages-lockscreen.html">Lockscreen</a></li>
                                        <li><a href="pages-recover-password.html">Recover password</a></li>
                                    </ul>
                                </li>
                                <li><a href="pages-profile.html">Profile page</a></li>
                                <li><a href="pages-animation.html">Animation</a></li>
                                <li><a href="pages-fix-innersidebar.html">Sticky Left sidebar</a></li>
                                <li><a href="pages-fix-inner-right-sidebar.html">Sticky Right sidebar</a></li>
                                <li><a href="pages-invoice.html">Invoice</a></li>
                                <li><a href="pages-treeview.html">Treeview</a></li>
                                <li><a href="pages-utility-classNamees.html">Helper ClassNameclassNamees</a></li>
                                <li><a href="pages-search-result.html">Search result</a></li>
                                <li><a href="pages-scroll.html">Scrollbar</a></li>
                                <li><a href="pages-pricing.html">Pricing</a></li>
                                <li><a href="pages-lightbox-popup.html">Lighbox popup</a></li>
                                <li><a href="pages-gallery.html">Gallery</a></li>
                                <li><a href="pages-faq.html">Faqs</a></li>
                                <li><a href="javascript:void(0)" className="has-arrow">Error Pages</a>
                                    <ul aria-expanded="false" className="collapse">
                                        <li><a href="pages-error-400.html">400</a></li>
                                        <li><a href="pages-error-403.html">403</a></li>
                                        <li><a href="pages-error-404.html">404</a></li>
                                        <li><a href="pages-error-500.html">500</a></li>
                                        <li><a href="pages-error-503.html">503</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li> <a className="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false"><i className="ti-pie-chart"></i><span className="hide-menu">Extra</span></a>
                            <ul aria-expanded="false" className="collapse">
                                <li><a href="chart-morris.html">Morris Chart</a></li>
                                <li><a href="chart-chartist.html">Chartis Chart</a></li>
                                <li><a href="chart-echart.html">Echarts</a></li>
                                <li><a href="chart-flot.html">Flot Chart</a></li>
                                <li><a href="chart-knob.html">Knob Chart</a></li>
                                <li><a href="chart-chart-js.html">Chartjs</a></li>
                                <li><a href="chart-sparkline.html">Sparkline Chart</a></li>
                                <li><a href="chart-extra-chart.html">Extra chart</a></li>
                                <li><a href="chart-peity.html">Peity Charts</a></li>
                                <li>
                                    <a className="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false"><span className="hide-menu">Icons</span></a>
                                    <ul aria-expanded="false" className="collapse">
                                        <li><a href="icon-material.html">Material Icons</a></li>
                                        <li><a href="icon-fontawesome.html">Fontawesome Icons</a></li>
                                        <li><a href="icon-themify.html">Themify Icons</a></li>
                                        <li><a href="icon-weather.html">Weather Icons</a></li>
                                        <li><a href="icon-simple-lineicon.html">Simple Line icons</a></li>
                                        <li><a href="icon-flag.html">Flag Icons</a></li>
                                        <li><a href="icon-iconmind.html">Mind Icons</a></li>
                                    </ul>
                                </li>
                                <li>
                                    <a className="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false"><span className="hide-menu">Maps</span></a>
                                    <ul aria-expanded="false" className="collapse">
                                        <li><a href="map-google.html">Google Maps</a></li>
                                        <li><a href="map-vector.html">Vector Maps</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </li>
                        <li> <a className="has-arrow waves-effect waves-dark" href="javascript:void(0)" aria-expanded="false"><i className="ti-align-left"></i><span className="hide-menu">Multi</span></a>
                            <ul aria-expanded="false" className="collapse">
                                <li><a href="javascript:void(0)">item 1.1</a></li>
                                <li><a href="javascript:void(0)">item 1.2</a></li>
                                <li> <a className="has-arrow" href="javascript:void(0)" aria-expanded="false">Menu 1.3</a>
                                    <ul aria-expanded="false" className="collapse">
                                        <li><a href="javascript:void(0)">item 1.3.1</a></li>
                                        <li><a href="javascript:void(0)">item 1.3.2</a></li>
                                        <li><a href="javascript:void(0)">item 1.3.3</a></li>
                                        <li><a href="javascript:void(0)">item 1.3.4</a></li>
                                    </ul>
                                </li>
                                <li><a href="javascript:void(0)">item 1.4</a></li>
                            </ul>
                        </li> */}
                        </ul>
                    </nav>
                </div>
            </aside>
        </>
    );
};

export default Topbar;
